/**
 * Utilidades para la gestión y validación de entidades Revendedor
 */

export const isActiveRevendedor = (revendedor) => {
  return revendedor && revendedor.estado === 'Activo' && !revendedor.deletedAt;
};

export const hasValidWhatsapp = (revendedor) => {
  return !!revendedor.whatsapp;
};

export const isReenviarCandidate = (revendedor) => {
  return isActiveRevendedor(revendedor) && hasValidWhatsapp(revendedor);
};
